import { Link } from "react-router-dom";
import FastSendLogo from "../components/FastSendLogo";

const FEATURES = [
  { icon: "⚡", title: "Fast Matching", desc: "The nearest available dispatcher gets offered your delivery in seconds." },
  { icon: "🔒", title: "Verified Delivery", desc: "A one-time PIN confirms every drop-off — no delivery marked done without it." },
  { icon: "🗺️", title: "Live Tracking", desc: "Watch your dispatcher move on the map in real time, from pickup to your door." },
  { icon: "🏢", title: "For Businesses Too", desc: "Agents, Fleet Owners, B2B, and Corporate accounts — built for scale." }
];

const VEHICLES = [
  { icon: "🚲", label: "Bicycle" },
  { icon: "🏍️", label: "Motorcycle" },
  { icon: "🚐", label: "Van" },
  { icon: "🚚", label: "Truck" }
];

// App Store badge components using SVG logos inline
function AppStoreBadge({ href }) {
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        background: "#000",
        color: "#fff",
        border: "1.5px solid rgba(255,255,255,0.2)",
        borderRadius: "10px",
        padding: "10px 18px",
        textDecoration: "none",
        transition: "transform 0.15s, box-shadow 0.15s",
        cursor: href ? "pointer" : "default"
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.4)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Apple logo SVG */}
      <svg width="22" height="26" viewBox="0 0 814 1000" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.5-155.5-127.4C46 790.7 0 663.9 0 541.8c0-148.4 96.7-226.4 190.5-226.4 50.4 0 92.3 32.4 124.4 32.4 30.6 0 78.7-34 140.8-34 22.4 0 108.2 2 161.4 86.1zm-197-188.3c27.8-33.4 47.6-79.9 47.6-126.3 0-6.5-.6-13-1.9-19.2-45.1 1.7-100 30.1-132.5 65.9-25.5 27.8-48.3 74.3-48.3 121.4 0 7.1 1.3 14.3 1.9 16.6 2.6.6 6.5 1.3 10.4 1.3 40.8 0 91.2-27.2 122.8-59.7z"/>
      </svg>
      <div style={{ lineHeight: 1.2, textAlign: "left" }}>
        <div style={{ fontSize: "10px", opacity: 0.8 }}>Download on the</div>
        <div style={{ fontSize: "16px", fontWeight: 700, letterSpacing: "-0.3px" }}>App Store</div>
      </div>
    </a>
  );
}

function PlayStoreBadge({ href }) {
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        background: "#000",
        color: "#fff",
        border: "1.5px solid rgba(255,255,255,0.2)",
        borderRadius: "10px",
        padding: "10px 18px",
        textDecoration: "none",
        transition: "transform 0.15s, box-shadow 0.15s",
        cursor: href ? "pointer" : "default"
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.4)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Google Play logo SVG */}
      <svg width="22" height="24" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l232.6-232.4L47 0zm439.6 218.1L401.7 170l-65.5 65.5 65.5 65.5 85.1-48.3c24.4-14.3 24.4-34.3-.2-34.6zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" fill="white"/>
      </svg>
      <div style={{ lineHeight: 1.2, textAlign: "left" }}>
        <div style={{ fontSize: "10px", opacity: 0.8 }}>Get it on</div>
        <div style={{ fontSize: "16px", fontWeight: 700, letterSpacing: "-0.3px" }}>Google Play</div>
      </div>
    </a>
  );
}

export default function Landing() {
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg-primary)", color: "var(--text-primary)" }}>
      {/* NAV */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", maxWidth: "1100px", margin: "0 auto" }}>
        <FastSendLogo variant="horizontal" size="small" />
        <div style={{ display: "flex", gap: "10px" }}>
          <Link to="/login"><button className="secondary" style={{ width: "auto", padding: "8px 18px", marginTop: 0 }}>Log In</button></Link>
        </div>
      </div>

      {/* HERO */}
      <div style={{ maxWidth: "720px", margin: "0 auto", textAlign: "center", padding: "40px 24px 60px" }}>
        <h1 style={{ fontSize: "clamp(28px, 6vw, 44px)", fontWeight: 800, lineHeight: 1.15, margin: 0 }}>
          Send anything, anywhere in the city —{" "}
          <span style={{ background: "var(--accent-gradient)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>
            fast.
          </span>
        </h1>
        <p style={{ color: "var(--text-secondary)", fontSize: "17px", marginTop: "16px" }}>
          From a document to a truckload — FastSend matches you with the nearest available dispatcher,
          on a bicycle, motorcycle, van, or truck.
        </p>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap", marginTop: "28px" }}>
          <Link to="/register/user">
            <button style={{ width: "auto", padding: "12px 28px" }}>📦 Send a Package</button>
          </Link>
          <Link to="/register/rider">
            <button className="secondary" style={{ width: "auto", padding: "12px 28px" }}>🛵 Become a Dispatcher</button>
          </Link>
        </div>

        {/* Vehicle strip */}
        <div style={{ display: "flex", justifyContent: "center", gap: "24px", flexWrap: "wrap", marginTop: "36px" }}>
          {VEHICLES.map(v => (
            <div key={v.label} style={{ textAlign: "center" }}>
              <div style={{ fontSize: "28px" }}>{v.icon}</div>
              <div style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "4px" }}>{v.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "0 24px 60px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px" }}>
          {FEATURES.map(f => (
            <div key={f.title} className="delivery-card" style={{ margin: 0 }}>
              <div style={{ fontSize: "26px" }}>{f.icon}</div>
              <div style={{ fontWeight: 700, marginTop: "8px" }}>{f.title}</div>
              <p style={{ fontSize: "13px", color: "var(--text-secondary)", marginTop: "4px" }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* APP DOWNLOAD SECTION */}
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "0 24px 60px" }}>
        <div
          className="delivery-card"
          style={{
            margin: 0,
            textAlign: "center",
            background: "linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(168,85,247,0.12) 100%)",
            border: "1px solid rgba(99,102,241,0.3)"
          }}
        >
          <div style={{ fontSize: "36px", marginBottom: "10px" }}>📱</div>
          <h3 style={{ marginTop: 0, fontSize: "20px" }}>Get the FastSend App</h3>
          <p className="hint" style={{ marginBottom: "24px", fontSize: "14px" }}>
            Track deliveries in real time, manage orders, and get notifications — right from your phone.
            Available for iPhone and Android.
          </p>
          <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
            <AppStoreBadge href={process.env.REACT_APP_IOS_STORE_URL || null} />
            <PlayStoreBadge href={process.env.REACT_APP_ANDROID_STORE_URL || null} />
          </div>
          <p style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "16px", marginBottom: 0 }}>
            Coming soon — our mobile apps are launching shortly. Stay tuned!
          </p>
        </div>
      </div>

      {/* BUSINESS CTA */}
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "0 24px 60px" }}>
        <div className="delivery-card" style={{ margin: 0, textAlign: "center" }}>
          <h3 style={{ marginTop: 0 }}>🏢 Running a business?</h3>
          <p className="hint" style={{ marginBottom: "16px" }}>
            Agent, Fleet Owner, B2B, and Corporate accounts — with API access, consolidated invoicing, and fleet rollups.
          </p>
          <Link to="/login">
            <button className="secondary" style={{ width: "auto", padding: "10px 24px" }}>Explore Business Accounts</button>
          </Link>
        </div>
      </div>

      <div style={{ textAlign: "center", padding: "20px 24px", color: "var(--text-muted)", fontSize: "13px" }}>
        © {new Date().getFullYear()} FastSend. Built for Nigeria's delivery hustle.
      </div>
    </div>
  );
}
